import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { Profile } from 'oidc-client';
import { DoHttpService } from 'src/app/core/services/do-http.service';
import { ApiUrls } from 'src/app/shared/constants/ApiUrls';

@Component({
  selector: 'app-notification-opener-icon',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatBadgeModule
  ],
  templateUrl: './notification-opener-icon.component.html',
  styleUrls: ['./notification-opener-icon.component.scss'],
})
export class NotificationOpenerIconComponent {

  @Input() userProfile: Profile;
  @Input() notificationData: any;

  @Output() closeAvatar = new EventEmitter();
  @Output() openNotificationEmit = new EventEmitter();

  @ViewChild('notificationIcon', {static: false}) notificationIcon: ElementRef;

  constructor(private request: DoHttpService) { }

  openNotification() {
    this.closeAvatar.emit();
    this.openNotificationEmit.emit();
    this.notificationIcon?.nativeElement.classList.add("open");
    this.request.put(ApiUrls.markNotificationSeen, null, true).subscribe();
  }

  closeNotification() {
    this.notificationIcon?.nativeElement.classList.remove("open");
  }
}
